import React, { useEffect, useState, useMemo } from 'react';
import BWAccordion from 'components/shared/BWAccordion';
import FormInput from 'components/shared/BWFormControl/FormInput';
import FormItem from 'components/shared/BWFormControl/FormItem';
import FormSelect from 'components/shared/BWFormControl/FormSelect';
import FormTextArea from 'components/shared/BWFormControl/FormTextArea';
import FormRangePicker from 'components/shared/BWFormControl/FormDateRange';
import FormNumber from 'components/shared/BWFormControl/FormNumber';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { getRequestTypeOpts } from 'services/request-warranty-repair';
import { useFormContext, useWatch } from 'react-hook-form';

const CouponInformation = ({ title, disabled }) => {
  const methods = useFormContext();
  const [requestTypeList, setRequestTypeList] = useState();

  const budget = useWatch({ name: 'budget' });
  const promationalList = useWatch({ name: 'promotional_list' });
  
  const totalValueCoupon = useMemo(() => {
    if (!promationalList || promationalList.length === 0) return 0;
    return promationalList.reduce((total, currentItem) => {
      return total + ((currentItem?.percent_value || 0) * budget / 100);
    }, 0);
  }, [promationalList, budget]);

  useEffect(() => {
    methods.setValue('total_coupon_value', totalValueCoupon);
  }, [totalValueCoupon]);

  const loadRequestType = useCallback(() => {
    getRequestTypeOpts().then((o) => {
      setRequestTypeList(
        o.map((p) => ({
          label: p?.request_type_name,
          value: p?.id,
        })),
      );
    });
  }, []);
  useEffect(loadRequestType, [loadRequestType]);

  return (
    <React.Fragment>
      <BWAccordion isRequired title={title}>
        <div className='bw_col_12'>
          <div className='bw_row'>
            <div className='bw_col_6'>
              <FormItem disabled={disabled} isRequired label='Tên chương trình'>
                <FormInput
                  disabled={disabled}
                  type='text'
                  field='coupon_name'
                  placeholder='Tên chương trình'
                  validation={{
                    required: 'Tên chương trình là bắt buộc',
                    validate: (p) => {
                      if (p.trim().length === 0) {
                        return 'Tên chương trình là bắt buộc';
                      }
                    },
                  }}
                />
              </FormItem>
            </div>
            <div className='bw_col_6'>
              <FormItem disabled={disabled} isRequired label='Thời gian áp dụng'>
                <FormRangePicker
                  style={{ width: '100%' }}
                  disabled={disabled}
                  fieldStart='start_date'
                  fieldEnd='end_date'
                  placeholder={['Từ ngày', 'Đến ngày']}
                  format={['DD/MM/YYYY', 'DD/MM/YYYY']}
                  validation={{
                    required: 'Cần chọn thời gian áp dụng',
                  }}
                />
              </FormItem>
            </div>
            <div className='bw_col_6'>
              <FormItem disabled={disabled} isRequired label='Ngân sách'>
                <FormNumber
                  min={0}
                  addonAfter='đ'
                  field='budget'
                  className=''
                  disabled={disabled}
                  bordered={false}
                  controls={false}
                  validation={{
                    required: 'Ngân sách là bắt buộc',
                    validate: (p) => {
                      if (p < methods.watch('total_coupon_value')) {
                        return 'Ngân sách phải lớn hơn hoặc bằng tổng giá trị coupon';
                      }
                    },
                  }}
                />
              </FormItem>
            </div>
            <div className='bw_col_6'>
              <FormItem disabled={true} isRequired label='Tổng giá trị Coupon'>
                <FormNumber
                  min={0}
                  bordered={false}
                  field='total_coupon_value'
                  addonAfter='đ'
                  // disabled={true}
                  // value={methods.watch('budget') ? methods.watch('budget') : 0}
                  validation={{
                    required: 'Tổng giá trị coupon là bắt buộc',
                  }}
                />
              </FormItem>
            </div>
            <div className='bw_col_12'>
              <FormItem disabled={disabled} isRequired label='Loại yêu cầu áp dụng'>
                <FormSelect
                  list={requestTypeList ?? []}
                  mode='multiple'
                  disabled={disabled}
                  type='text'
                  field='request_type_list'
                  validation={{
                    required: 'Loại yêu cầu áp dụng là bắt buộc',
                  }}
                />
              </FormItem>
            </div>
            <div className='bw_col_12'>
              <FormItem disabled={disabled} label='Ghi chú'>
                <FormTextArea type='text' field='description' placeholder='Mô tả' />
              </FormItem>
            </div>
          </div>
        </div>
      </BWAccordion>
    </React.Fragment>
  );
};

CouponInformation.propTypes = {
  title: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default CouponInformation;
